import { mapActions, mapGetters } from 'vuex'

import PublicPageWrapper from '@/components/PublicPageWrapper'
import MainButton from '@/components/MainButton/index'
import ResponseDialog from '@/components/ResponseDialog/index'
import Logo from '@/assets/the-long-ball-logo.svg'

export default {
  name: 'forgot-password',
  components: {
    PublicPageWrapper,
    MainButton,
    ResponseDialog
  },
  data: () => ({
    emailAddress: '',
    emailRules: [
      v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'E-mail must be valid'
    ],
    loading: false,
    responseDialog: false,
    responseDialogMessage: '',
    routerName: 'forgot-password',
    emailField: false,
    Logo
  }),
  computed: {
    ...mapGetters('forgotPassword', {
      postEmailResponse: 'FORGOT_PASSWORD_RESPONSE'
    })
  },
  methods: {
    ...mapActions('forgotPassword', {
      postEmail: 'SEND_FORGOT_PASSWORD'
    }),
    submitEmail() {
      if (this.$refs.emailField.validate()) {
        this.loading = true

        if (this.emailAddress) {
          this.postEmail({
            email: this.emailAddress
          }).then(() => {
            const { message, success } = this.postEmailResponse.data
            this.responseDialogMessage = message

            if (success) {
              this.routerName = 'login'
            }

            this.responseDialog = true
            this.loading = false
          })
        }
      }
    },
    responseDialogClick() {
      this.emailAddress = ''
      this.responseDialog = false
      this.$router.push({ name: this.routerName })
    }
  }
}
